// 🔒 VALIDAÇÃO CRÍTICA DA JORNADA - APENAS 3 MÚSICAS GRATUITAS
export const FREE_JOURNEY_SONGS = [22, 23, 453];

/**
 * Verifica se uma música da jornada é gratuita
 * @param songId - ID da música
 * @returns true se a música é gratuita na jornada
 */
export function isFreeJourneySong(songId: number): boolean {
  return FREE_JOURNEY_SONGS.includes(Number(songId));
}

/**
 * Verifica se um usuário pode acessar uma música da jornada
 * @param songId - ID da música
 * @param userType - Tipo de conta do usuário ('premium', 'free', 'convidado', etc.)
 * @returns true se o usuário pode acessar a música
 */
export function canAccessJourneySong(songId: number, userType?: string): boolean {
  return userType === 'premium' || isFreeJourneySong(songId);
}

/**
 * Filtra músicas da jornada baseado no tipo de usuário
 * @param songs - Array de músicas
 * @param userType - Tipo de conta do usuário
 * @returns Array filtrado de músicas que o usuário pode acessar
 */
export function filterJourneySongs<T extends { id: number | string }>(
  songs: T[], 
  userType?: string
): T[] {
  if (userType === 'premium') {
    return songs;
  }
  
  return songs.filter(song => isFreeJourneySong(Number(song.id)));
} 